export enum StreetName {
  PRE_FLOP,
  FLOP,
  TURN,
  RIVER,
  SHOWDOWN,
}

export const STREETS = {
  [StreetName.PRE_FLOP]: { name: "pre-flop" },
  [StreetName.FLOP]: { name: "flop" },
  [StreetName.TURN]: { name: "turn" },
  [StreetName.RIVER]: { name: "river" },
  [StreetName.SHOWDOWN]: { name: "showdown" },
};

export const getRound = (boardLength: number) => {
  if (boardLength == 0) return StreetName.PRE_FLOP;
  if (boardLength <= 3) return StreetName.FLOP;
  if (boardLength <= 4) return StreetName.TURN;
  if (boardLength <= 5) return StreetName.RIVER;
  return StreetName.SHOWDOWN;
};
